function resizeToFitContent(el) {
  el.style.height = "auto";
  el.style.height = `${el.scrollHeight}px`;
}

// Grows a textarea's height to fit its content, no scrollbar. Height can't
// use CSS field-sizing: content since Electron's bundled Chromium predates
// it, so this recalculates on input and on every re-render of the owning
// component (v-model changes don't fire 'input' on their own).
export const vAutogrow = {
  mounted(el) {
    resizeToFitContent(el);
    // The panel this sits in is still settling layout (widths, fonts) at
    // mount time, so the immediate measurement above can be too small.
    // Re-measure once the browser has painted a frame.
    requestAnimationFrame(() => resizeToFitContent(el));
    el.addEventListener("input", () => resizeToFitContent(el));
  },
  updated(el) {
    resizeToFitContent(el);
  },
};

export function cardTitleBg(nodeType) {
  if (nodeType == "detour") return "#655A9D";
  if (nodeType == "logic") return "#4A7A99";
  if (nodeType == "operator") return "#b23440";
  if (nodeType == "start") return "#DE821B";
  if (nodeType == "end") return "#DE821B";
  if (nodeType == "meta") return "#7F7F1E";
  if (nodeType == "note") return "#8a7a00";
  return "#25846B";
}
